module.exports = __webpack_public_path__ + "img/product-placeholder-13.0bd29f7.png";